import * as React from 'react'
import { Box, Button, TextField } from '@mui/material'
import { Delete } from '@mui/icons-material'
import {
  retrieveIngestedTree,
  deletePartnerFile,
  UrlKey,
  createTreeFromIngestion,
} from './Utility'
import { AccordionWrapper } from '../utility/AccordianWrapper'
import { CollapsableJson } from 'shared/ui'
import { useCurrentUserResource } from 'infrastructure/auth/auth.hooks'
import { useNavigateTo } from 'infrastructure/routing'
import { useAtom, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { ingestedFilesAtom, partnerIdAtom } from './atoms'
import { AwsContentItem } from 'shared/types/ingestion'
import { IngestedPreviewButton } from './IngestedPreviewButton'
import { NodeSearchParams, openNode } from '../utility/TreeNavigation'

export function Ingested({ partnerKey }: { partnerKey: string }) {
  useSetAtom(partnerIdAtom)(partnerKey)
  const [files, refreshFiles] = useAtom(ingestedFilesAtom)
  const [ingestedTree, setIngestedTree] = React.useState<any>()
  const [currentError, setCurrentError] = React.useState<string | undefined>()

  const navigate = useNavigateTo()
  const goToIngested = (ingestedId: string) =>
    navigate(`/ingestion/partner/${partnerKey}/ingested/${ingestedId}`)

  function convertTree(tree: AwsContentItem) {
    retrieveIngestedTree(partnerKey, tree.key).then(({ tree, error }) => {
      setIngestedTree(tree)
      setCurrentError(error?.replace(/(?:\r\n|\r|\n)/g, '<br>'))
    })
  }

  function deleteFile(fileName: string) {
    deletePartnerFile(partnerKey, fileName, UrlKey.ingestionUpload, () => {
      refreshFiles()
    })
  }

  return (
    <Box>
      <Box>Ingested</Box>
      <AccordionWrapper title={`Files ${files.length}`}>
        <Box>
          {files.map((f) => {
            return (
              <Box key={f.key}>
                <Box>
                  <Button onClick={() => convertTree(f)}>{f.key}</Button>
                  <IngestedPreviewButton ingestionKey={f.key} />
                  <Button onClick={() => deleteFile(f.key)}>
                    <Delete />
                  </Button>
                  <Button onClick={() => goToIngested(f.key)}>Go</Button>
                  <CreateTreeFromIngestion
                    ingestionKey={f.key}
                    partnerKey={partnerKey}
                  />
                </Box>
              </Box>
            )
          })}
        </Box>
      </AccordionWrapper>
      {currentError && (
        <Box padding={'5px'}>
          <span dangerouslySetInnerHTML={{ __html: currentError }} />
        </Box>
      )}
      <Box>
        <CollapsableJson json={ingestedTree} title={''} collapsed={true} />
      </Box>
    </Box>
  )
}

export function CreateTreeFromIngestion({
  ingestionKey,
  partnerKey,
}: {
  ingestionKey: string
  partnerKey: string
}) {
  const [asTree, setAsTree] = React.useState<{
    id: number
    tree_id: string
    tree_version: string
  }>()
  const currentUser = useCurrentUserResource()
  const [doingIt, setDoingIt] = React.useState(false)
  const [userId, setUserId] = React.useState(currentUser?.id)

  function createFromIngested() {
    createTreeFromIngestion({
      partner_key: partnerKey,
      ingestion_key: ingestionKey,
      user_id: userId,
    }).then(({ curricula }) => {
      setAsTree(curricula)
    })
  }

  if (asTree) {
    return (
      <Box>
        {`${asTree.id} ${asTree.tree_id}:${asTree.tree_version}`}
        <Button onClick={() => openNode(asTree as unknown as NodeSearchParams)}>
          Open
        </Button>
      </Box>
    )
  }

  if (doingIt) {
    return (
      <>
        <TextField
          label={'User ID'}
          value={userId}
          onChange={(e) => setUserId(parseInt(e.target.value, 10))}
        />
        <Button onClick={createFromIngested}>Confirm</Button>
      </>
    )
  }

  return <Button onClick={() => setDoingIt(true)}>Create Tree</Button>
}
